import { render, staticRenderFns } from "./LastPurchaseRefresh.vue?vue&type=template&id=d67671d6&"
import script from "./LastPurchaseRefresh.vue?vue&type=script&lang=js&"
export * from "./LastPurchaseRefresh.vue?vue&type=script&lang=js&"
import style0 from "./LastPurchaseRefresh.vue?vue&type=style&index=0&id=d67671d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports